/** Client-side mirror of backend/app/util/polygon.py's point_in_polygon().
 *
 * Both must use identical algorithms so the on-map "N voters in this area"
 * count agrees with the walk-list result the backend returns. If you change
 * one, change the other.
 */

export interface PolygonVertex {
  lng: number;
  lat: number;
}

/** Even-odd ray-casting. Cast a horizontal ray from (lat, lng) and count
 * edge crossings. Odd count = inside. Handles non-convex polygons.
 * Self-intersecting polygons produce a defined-but-quirky result. */
export function pointInPolygon(
  lat: number,
  lng: number,
  vertices: PolygonVertex[],
): boolean {
  const x = lng;
  const y = lat;
  const n = vertices.length;
  let inside = false;
  let j = n - 1;
  for (let i = 0; i < n; i++) {
    const xi = vertices[i].lng;
    const yi = vertices[i].lat;
    const xj = vertices[j].lng;
    const yj = vertices[j].lat;
    if (
      yi > y !== yj > y &&
      x < ((xj - xi) * (y - yi)) / (yj - yi) + xi
    ) {
      inside = !inside;
    }
    j = i;
  }
  return inside;
}
